module.exports = __webpack_public_path__ + "media/promo/advent/images/bg-08b107467679a5c9dd1dc1e0cef1d8bf.jpg";